// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Hutu","tabsBox":"styles_tabsBox__3uV-4","createButton":"styles_createButton__3X5NX"};